module.exports = __webpack_public_path__ + "images/emoji/eyeglasses.432095c29b12a16b1d59.png";